import { API_URI, BASE_URI, CLIENT_ID, CLIENT_SECRET } from '../settings';
import { TrackEvent } from './TrackEvent';
import { setSignupEmail, setSignupCompleted } from '../Actions/actions_signup';
import * as UserActions from '../Actions/actions_user';
import * as ProfileActions from '../Actions/actions_profile';
import { Identify } from './Identify';
import { toast } from 'react-toastify';
import moment from 'moment';
import * as qs from 'qs';

export default {
  // Commented out as part of ticket to remove Google SSO
  async getSocialIDs() {
    const response = await fetch(`${API_URI}socials/`);
    if (response.status === 200) return response.json();
    throw await response.json;
  },
  async verifyHash(hash) {
    const response = await fetch(`${API_URI}user/beta-registration/check/`, {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({ hash }),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },
  // Commented out as part of ticket to remove Google SSO
  // async convertToken(backend, token, create = false) {
  //   const tokenToConvert = {
  //     grant_type: 'convert_token',
  //     client_id: CLIENT_ID,
  //     client_secret: CLIENT_SECRET,
  //     backend,
  //     token,
  //     register: create,
  //   };
  //   const response = await fetch(`${BASE_URI}auth/convert-token/`, {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(tokenToConvert),
  //   });
  //   if (response.status === 200) return response.json();
  //   throw await response.json();
  // },
  async sendPasswordReset(email) {
    const response = await fetch(`${API_URI}user/password-reset/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },
  async resetPassword(hash, password) {
    const response = await fetch(`${API_URI}user/password-reset/complete/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password, hash }),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },
  // Commented out as part of ticket to remove Google SSO
  // async getGoogleProfile(access_token) {
  //   const response = await fetch(
  //     `https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${access_token}`
  //   );
  //   return await response.json();
  // },
  async login(email, password) {
    const formData = {
      grant_type: 'password',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      username: email,
      password,
    };
    const response = await fetch(`${BASE_URI}auth/token/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },
  async refreshToken() {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) return;
    const currentToken = {
      grant_type: 'refresh_token',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      refresh_token: refreshToken,
    };
    const response = await fetch(`${BASE_URI}auth/token/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(currentToken),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },
  async isAlive() {
    const response = await fetch(`${API_URI}status/`);
    if (response.status === 200) return true;
    throw await false;
  },
  async createBetaPassword(hash, password, tosAccepted) {
    const response = await fetch(`${API_URI}user/beta-registration/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password, hash, tosAccepted }),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },
  // Commented out as part of ticket to remove Google SSO
  async userSignup(email, password, campaignId) {
    const formData = {
      // client_id: CLIENT_ID,
      // client_secret: CLIENT_SECRET,
      email: email,
      password: password,
      campaign_id: campaignId,
    };
    const response = await fetch(`${API_URI}v2/user/signup/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    if (response.status === 200) return response.json();
    throw await response.json();
  },

  routeWithParams(path, props) {
    const params = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    const queryParams = new URLSearchParams(params).toString();
    if (queryParams) props.history.push(`/${path}/?${queryParams}`);
    else props.history.push(`/${path}`);
  },

  successUserLoginNavigation(props) {
    const parsed = qs.parse(
      props.location.search.slice(1, props.location.search.length)
    );
    let url = '/dashboard';
    if ('redirect' in parsed) url = parsed.redirect;
    props.history.push(url);
  },

  isProfileCompleted(data) {
    const [preferences, categories, about, information, , profile] = data;
    const aboutReady = !!about.about;
    const foodReady = !!about.favoriteFood;
    const locationReady = !!information.location;
    const preferencesReady = !!preferences.meetingPreference;
    const occupationReady = about.occupation;
    const weaknessReady = !!about.weakness;
    const languagesReady =
      information && information.languages && information.languages.length > 0;
    const strengthReady = !!about.strength;
    const birthdayReady = !!profile.date_of_birth;
    const nameReady = !!information.name;
    const categoriesReady =
      categories && categories.filter((e) => e.active).length > 0;
    return !!(
      aboutReady &&
      foodReady &&
      locationReady &&
      preferencesReady &&
      occupationReady &&
      weaknessReady &&
      languagesReady &&
      strengthReady &&
      birthdayReady &&
      nameReady &&
      categoriesReady
    );
  },

  async afterUserSignup(email, event, props) {
    TrackEvent(event);
    props.setSignupEmail(email);
    props.setSignupCompleted();
    localStorage.setItem('email_verification_to', email);
  },

  async afterUserLogin(data, event, props) {
    TrackEvent(event);
    try {
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem(
        'expires',
        moment().add(data.expires_in, 'seconds').format()
      );

      const userData = await props.fetchUserData();
      props.updateUser(userData, false, true);
      const res = await Promise.all([
        props.fetchUserPreferences(userData.pk),
        props.fetchUserCategories(userData.pk),
        props.fetchUserAbout(userData.pk),
        props.fetchUserInformation(userData.pk),
        props.fetchUserSubscription(userData.pk),
      ]);
      Identify(userData, {
        subscription: res[4],
      });
      const profileReady = this.isProfileCompleted([...res, userData]);
      if (profileReady) this.successUserLoginNavigation(props);
      else props.history.push('/profile');
    } catch (e) {
      console.info(e);
      toast.error(`Login failed. ${e.error_description || ''}`);
    }
  },
};
